import {
    Form,
    Input,
    Button,
    Select,
    Upload,
    Result,
    message
} from "antd";
import { InboxOutlined } from '@ant-design/icons';
import { useState } from "react";
import { useForm } from "antd/lib/form/Form";
import { signularisApi, useCreateMetaDocumentMutation, useGetRecipientsListQuery } from "../../store/api/signularisApi";
import { useAppDispatch } from "../../hooks/redux";
import {useNavigate} from "react-router-dom";
import {MAIN_PAGE_ROUTE, TEMPLATES_CREATE_DOCUMENT_ROUTE} from "../../routing/consts";
import useSetTitle from "../../hooks/useSetTitle";
import {DocTemplateType} from "../../types/types";
import style from './CreateDocument.module.scss';

const { Item } = Form;
const { TextArea } = Input;
const { Dragger } = Upload;
const { Option } = Select;

type CreateMetaDocumentRequest = {
    title:      string,
    brief:      string,
    recipients: string[],
    file:       File,
}

function Create() {
    const dispatch = useAppDispatch()

    useSetTitle('Создание документа')


    const { data: recipientsList } = useGetRecipientsListQuery()

    const [docname, setDocname] = useState("")
    const docTemplate : DocTemplateType = 'default'

    const [createMetaDocument, {
        isLoading: mutationLoading,
        isSuccess: mutationSuccess,
        isError: mutationError,
    } ] = useCreateMetaDocumentMutation()

    const [form] = useForm()
    const navigate = useNavigate();

    const onFinish = (values: CreateMetaDocumentRequest) => {
        setDocname(values.title)
        const formData = new FormData()
        formData.append("title", values.title)
        formData.append("referenceType", docTemplate)
        formData.append("brief", values.brief)
        formData.append("recipients", values.recipients.join(","))
        if (uploadFile !== undefined) {
            formData.append("file", uploadFile, uploadFile?.name)
        }
        createMetaDocument(formData)
        dispatch(signularisApi.util.invalidateTags(['MetaDocument']))
    }

    const [uploadFile, setUploadFile] = useState<File>()

    const handleUpload = (uploadObj: any) => {
        if (uploadObj.fileList[0] !== undefined) {
            setUploadFile(uploadObj.fileList[0].originFileObj)
        } else {
            setUploadFile(uploadObj.file)
        }
    }

    const handleDelete = () => {
        message.warning(`Файл ${uploadFile?.name} удален`)
        setUploadFile(undefined)
    }

    const handleBeforeUpload = (file: File) => {
        if (file.type !== "application/pdf") {
            message.error("Разрешены файлы только в формате PDF")
            return Upload.LIST_IGNORE
        }
        return false
    }

   if (mutationSuccess) return (
        <Result
            status="success"
            title="Документ успешно создан"
            extra={<Button type="primary" size="large" href="/user/create">Создать еще один</Button>}
        />
    );

    return (
        <div className={style.container}>
            <div className={style.formWrapper}>
                <h2 style={{ marginBottom: 24, fontWeight: 800 }}>Новый документ</h2>
                <Form form={form} onFinish={onFinish} layout="vertical">
                    <Item label="Название документа" name="title" rules={[{ required: true, message: 'Введите название' }]}>
                        <Input placeholder="Напр: Требование-накладная №..." size="large" />
                    </Item>

                    <Item label="Получатели" name="recipients" rules={[{ required: true, message: 'Выберите хотя бы одного получателя' }]}>
                        <Select
                            mode="multiple"
                            size="large"
                            placeholder="Начните вводить ФИО..."
                            filterOption={(input, option) =>
                                (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {recipientsList?.map(r => (
                                <Option key={r.id} value={r.id} label={r.fullname}>
                                    {r.fullname} {r.position && <span style={{color: '#94a3b8', fontSize: 12}}> — {r.position}</span>}
                                </Option>
                            ))}
                        </Select>
                    </Item>

                    <Item label="Краткое описание" name="brief" rules={[{ required: true, message: 'Опишите суть документа' }]}>
                        <TextArea rows={4} placeholder="О чем этот документ?" />
                    </Item>

                    <Item label="Файл документа (PDF)" name="file" rules={[{ required: true, message: 'Прикрепите файл' }]}>
                        <Dragger
                            accept='application/pdf'
                            maxCount={1}
                            beforeUpload={handleBeforeUpload}
                            onChange={handleUpload}
                            onRemove={handleDelete}
                            style={{ borderRadius: 12, background: '#f8fafc' }}
                        >
                            <p className={style.draggerIcon}><InboxOutlined /></p>
                            <p className="ant-upload-text">Нажмите или перетащите файл</p>
                            <p className="ant-upload-hint">Только PDF файлы</p>
                        </Dragger>
                    </Item>

                    <div style={{ display: 'flex', gap: 12, marginTop: 32 }}>
                        <Button type="primary" size="large" htmlType="submit" loading={mutationLoading} style={{ flex: 1 }}>
                            Создать и отправить
                        </Button>
                        <Button size="large" onClick={() => navigate(MAIN_PAGE_ROUTE + '/' + TEMPLATES_CREATE_DOCUMENT_ROUTE)}>
                            Использовать шаблон
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
}

export default Create;